"use client";

import { Phone } from "lucide-react";
import styles from "./FloatingContactButtons.module.css";

const WhatsappIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12.012 2c-5.506 0-9.989 4.478-9.99 9.984a9.96 9.96 0 0 0 1.333 4.982L2 22l5.202-1.362a9.92 9.92 0 0 0 4.808 1.258h.005c5.507 0 9.99-4.478 9.99-9.984A9.99 9.99 0 0 0 12.012 2zm4.7 13.99c-.26.732-1.282 1.34-2.127 1.417-.577.053-1.332.083-3.874-.969-3.25-1.344-5.342-4.636-5.505-4.854-.162-.217-1.3-1.727-1.3-3.298 0-1.572.822-2.343 1.114-2.654.29-.311.632-.39.843-.39h.6c.162 0 .374.062.585.57.21.507.714 1.745.776 1.87.062.126.104.272.02.44-.082.167-.123.272-.246.413-.122.14-.256.313-.365.42-.122.12-.25.25-.107.495.143.245.634 1.04 1.36 1.688.932.83 1.718 1.087 1.96 1.21.244.12.385.1.528-.066.142-.167.625-.726.79-1.033.167-.308.333-.257.562-.172.23.084 1.455.686 1.705.81.25.126.417.188.479.294.062.107.062.62-.2 1.354z"/>
  </svg>
);

export default function FloatingContactButtons() {
  return (
    <div className={styles.container}>
      {/* WhatsApp Button (Bottom-Left) */}
      <a
        href="https://wa.me/919599287096?text=Hi,%20I'm%20interested%20in%20Moteligo%20hotel%20management%20solutions!"
        target="_blank"
        rel="noreferrer"
        className={`${styles.floatBtn} ${styles.whatsappBtn}`}
        aria-label="Contact WhatsApp"
        id="global-whatsapp-float"
      >
        <WhatsappIcon />
        <span className={styles.tooltip}>Chat with us</span>
      </a>

      {/* Phone Button (Bottom-Right) */}
      <a
        href="tel:+919599287096"
        className={`${styles.floatBtn} ${styles.phoneBtn}`}
        aria-label="Call support"
        id="global-phone-float"
      >
        <Phone size={24} />
        <span className={styles.tooltip}>Call us</span>
      </a>
    </div>
  );
}
